import React, { useState, useEffect } from 'react';
import { Redirect } from 'react-router';
import { Grid } from '@material-ui/core';
import UserContext from '../../../../utils/UserContext';
import { isLogin } from '../../../../services/AuthService';
import CompanyManagement from '../CompanyManagement';
import MassMessageManagementCompany from '../MassMessageManagement/MassMessageManagementCompany';
import CompanyStateBar from '../../../../components/ManagementState/CompanyStateBar';
import ReportsManagementCompany from '../ReportsManagement/ReportsCompany';
import OfferReportManagement from '../OfferReportManagement';
import './GeneralCompanyManagement.scss';
import MassMessageScheduled from '../../../../components/MassMessage/MassMessageScheduled';
import { getScheduledMassiveEmail } from '../../../../services/AdminServices';

const GeneralCompanyManagement: React.FC = () => {
  const userContext = React.useContext(UserContext);
  const [selectedSection, setSelectedSection] = useState<string>('');
  const [countScheduled, setCountScheduled] = useState<number>(0);


  const getInitialData = async () => {

    const getInfo: any = await getScheduledMassiveEmail("company", true);
    if (getInfo.status === 200) {
      let resultList: number = (await getInfo.json()).count;

      setCountScheduled(resultList);
      console.log(resultList)
    }
  }

  useEffect(() => {
    window.scrollTo(0, 0);
    getInitialData();
    const urlPath = window.location.href;
    if (urlPath.includes('/empresas')) {
      setSelectedSection('Gestion');
      userContext.setStateCompanySection('Gestion');
    } else if (urlPath.includes('mensajeria-empresas')) {
      setSelectedSection('Mensajeria');
      userContext.setStateCompanySection('Mensajeria');
    } else if (urlPath.includes('empresas')) {
      setSelectedSection('Reportes');
      userContext.setStateCompanySection('Reportes');
    } else if (urlPath.includes('mensajeria-programada')) {
      setSelectedSection('Programada');
      userContext.setStateGraduateSection('Programada');
    } else {
      setSelectedSection('Ofertas');
      userContext.setStateCompanySection('Ofertas');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.location.href])


  return (
    <>
      {isLogin() ?
        <>
          <Grid item xs={12} className="state-bar-section">
            <CompanyStateBar selected={selectedSection} countScheduled={countScheduled} />
          </Grid>
          {selectedSection === "Gestion" &&
            <Grid container item xs={12}>
              <CompanyManagement />
            </Grid>
          }
          {selectedSection === "Mensajeria" &&
            <Grid container item xs={12}>
              <MassMessageManagementCompany />
            </Grid>
          }
          {selectedSection === "Programada" &&
            <Grid container item xs={12}>
              <MassMessageScheduled />
            </Grid>
          }
          {selectedSection === "Reportes" &&
            <ReportsManagementCompany />
          }
          {selectedSection === "Ofertas" &&
            <OfferReportManagement />
          }
        </>
        :
        <Redirect to="/" />
      }
    </>
  )
}

export default GeneralCompanyManagement;